import React from 'react'
import { Alert } from '@mui/material'
import { AccessTime } from '@mui/icons-material'
import Colors from 'utils/Colors'
import _ from 'lodash'
import styles from './styles'
import BuildFinancialPendings from './BuildFinancialPendings'
import BuildScoreData from './BuildScoreData'

const ReferenceCheck = ({ rfcData }) => {
  const classes = styles()
  const financialPendingsData = rfcData?.financial_pendings_data?.details?.data
  const score = rfcData?.credit_score_data?.quod_score
  const isApproved = rfcData?.result === 'APPROVED'
  const reason = rfcData?.financial_pendings_data?.reason
  const hasReviews = !_.isEmpty(rfcData?.reviews)
  
  const getStatusText = () => {
    if (rfcData?.result === 'WAITING_FOR_REVIEW') {
      return 'Revisão manual requerida'
    }
    if (hasReviews && !isApproved) {
      return 'Reprovado(a) após revisão manual'
    }
    if (hasReviews && isApproved) {
      return 'Aprovado(a) após revisão manual'
    }
    return !isApproved ? 'Reprovado(a) automaticamente'
    : score >= 600
    ? 'Aprovado(a) automaticamente por score'
    : 'Aprovado(a) automaticamente'
  }

  const getDescriptionText = () => (
    (isApproved && score >= 600) ? 
            'O score de crédito é alto o suficiente para que essa pessoa seja aprovada automaticamente na Análise de Crédito, dispensando a consulta de Pendências Financeiras.'
            : reason
  )
  


  return rfcData ? (
    <div>
      {rfcData?.status === 'PROCESSING' && (
        <Alert style={{ marginBottom: 12 }} color="primary" icon={<AccessTime />}>
          A Análise de Crédito ainda está processando, por favor aguarde para ter informações completas.
        </Alert>
      )}

      {rfcData?.status === 'PROCESSED' && (
        <div>
          <div  className={classes.scoreResume}>
            <span>
              <b>Situação:&nbsp;</b>
              <b style={{ color: isApproved ? Colors.green : Colors.red }}>{getStatusText()}</b>
            </span>
            <span>
              <b>Resultado da Análise:&nbsp;</b>
              {getDescriptionText()}
              </span>
          </div>
        </div>

      )}

      <br></br>

      {score && <BuildScoreData score={score} />}

      {financialPendingsData && <BuildFinancialPendings financialPendingsData={financialPendingsData} />}
    </div>
  ) : (
    <div className={classes.expansibleContent}>
      <span>Nenhuma informação encontrada.</span>
    </div>
  )
}

export default ReferenceCheck
